import React from 'react';
import { TestimonialCard } from './TestimonialCard';
import { testimonials } from '../data/testimonials';
export function Testimonials() {
  return <section aria-label="Student testimonials" className="bg-transparent" data-id="element-183" data-mp="3ksgyi97eejdg">
      <div className="mx-auto max-w-6xl px-5 py-10" style={{
      paddingTop: "17px",
      paddingBottom: "19px"
    }} data-id="element-184" data-mp="3fycofh2u5v85">
        <h2 className="text-center font-display text-2xl font-black text-plum sm:text-3xl" data-id="element-185" data-mp="3b01e758mpipe">
          🗣️ Real Testimonials From Professionals Who Already Started
        </h2>
        <div className="mt-8 grid w-full grid-cols-1 gap-5 md:grid-cols-3 md:gap-6" data-id="element-186" data-mp="31yuw4rqbzzu1">
          {testimonials.map((t, i) => <TestimonialCard key={t.name} testimonial={t} delay={i * 0.1} data-id="element-187" data-mp="2x1bk7yh3vz59" data-mpi={i} />)}
        </div>
      </div>
    </section>;
}